import { render } from "./excursionInfo.vue?vue&type=template&id=02e98054&scoped=true"
import script from "./excursionInfo.vue?vue&type=script&lang=js"
export * from "./excursionInfo.vue?vue&type=script&lang=js"

import "./excursionInfo.vue?vue&type=style&index=0&id=02e98054&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e98054"]])

export default __exports__